var Frontend = {


    init: function () {
        for (var object in this) {
            if (object != 'init' && object != 'hasher') {
                if (typeof Frontend[object] == 'object') {
                    for (var child in Frontend[object]) {
                        Frontend[object][child]();
                    }
                }
                if (typeof Frontend[object] == 'function') {
                    Frontend[object]();
                }
            }
        }
    },

    detectIEBrowser: function() {
        var rv = -1;
        if (navigator.appName == 'Microsoft Internet Explorer')
        {
            var ua = navigator.userAgent;
            var re  = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
            if (re.exec(ua) != null)
                rv = parseFloat( RegExp.$1 );
        }
        else if (navigator.appName == 'Netscape')
        {
            var ua = navigator.userAgent;
            var re  = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
            if (re.exec(ua) != null)
                rv = parseFloat( RegExp.$1 );
        }
        if(rv != -1) {
            $('html').addClass('ie').addClass('ie-' + rv)
        }
    },

    detectSafariBrowser: function() {
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if(isSafari) {
            $('html').addClass('safari')
        }
    },

    login: {

        label: function () {
            $('.login label').click(function () {
                $(this).next().focus();
            })
            return true;
        }

    },

    facilities: {

        dropdown: function () {
            $('.profile-picture .dropdown-toggle').click(function (event) {
                event.preventDefault();
                if (!$(this).hasClass('active')) {
                    $(this).next().show();
                    $(this).addClass('active');
                    $(".frontend-filter-search").focus();
                } else {
                    $(this).next().hide();
                    $(this).removeClass('active');
                }
            })
        },

        checkbox: function () {
            $('.profile-picture input[type=checkbox]').change(function () {
                var checked = $('.profile-picture input[type=checkbox]:checked')
                if (checked.length == 0) {
                    $(this).prop('checked', true);
                    return false;
                }
            })
        }

    },

    incidents: {

        tooltip: function () {
            $('[data-toggle="tooltip"]').tooltip({
                container: 'body'
            });
        },

        globalfilter: function () {
            var openFacilityFilterHandler = function (e) {
                var event = document.createEvent('Event');
                event.initEvent('searchComponent.cancel', true, true);
                window.dispatchEvent(event);

                $('.filters__facilities .dropdown-toggle').trigger('click');
                return false;
            };

            Mousetrap.bind('alt+f', openFacilityFilterHandler);
            Mousetrap.bind('alt+a', openFacilityFilterHandler);
        }

    },

    changeApplyButtonStyleOnChange: function () {
        // var $filters = $('.filters')
        // var $filtersInput = $('.filters :input')
        // var $filterApplyButton = $('.apply-filter')
        // var defaultClass = 'btn-knapp-dark'
        // var activeClass = 'btn-success'
        // var changeApplyButtonToActiveStyle = function () {
        //     $filterApplyButton
        //         .removeClass(defaultClass)
        //         .addClass(activeClass)
        // }
        // var changeApplyButtonToDefaultStyle = function () {
        //     $filterApplyButton
        //         .removeClass(activeClass)
        //         .addClass(defaultClass)
        // }
        // $filters.one('click', function () {
        //     $filtersInput.change(changeApplyButtonToActiveStyle)
        //     $filtersInput.keydown(changeApplyButtonToActiveStyle)
        //
        // })
        // $filterApplyButton.click(function () {
        //     changeApplyButtonToDefaultStyle()
        // })
    },

    hasher: {
        registerCallback: function(callback) {
            var callback = callback

            $(window).on('hashchange', function () {
                var query = Frontend.hasher.parseHash()
                callback(query)
            })

            Frontend.hasher.currentHashParameters(callback);
        },

        currentHashParameters: function(callback) {
            var callback = callback

            if (location.hash) {
                var query = Frontend.hasher.parseHash()
                callback(query)
            }
        },

        parseHash: function() {
            var query = {};
            var rawQuery = location.hash.replace('#', '').split('&');
            for (i = 0; i < rawQuery.length; i++) {
                var splited = rawQuery[i].split('=');
                if (typeof splited[1] == 'undefined') {
                    splited[1] = true
                }
                query[splited[0]] = splited[1]
            }

            return query
        },

        setHashParameter: function(parameterName, parameterValue) {
            var query = Frontend.hasher.parseHash();

            query[parameterName] = parameterValue;

            location.hash = Frontend.hasher.queryToHash(query);
        },

        queryToHash: function (query) {
            var hash = "";
            var i = 0;

            for (var key in query) {
                if (key != "" && query.hasOwnProperty(key)) {
                    if (i > 0) {
                        hash = hash + "&" + key + "=" + query[key];
                    } else {
                        hash = hash + key + "=" + query[key];
                    }

                    i++;
                }
            }

            return hash;
        }
    }

}

$(document).ready(function () {
    Frontend.init();
})